// src/pages/helpers/salesHandlers.js
// Ürün satış kayıtları handler fonksiyonları

import { db } from '../../firebase';
import { doc, collection, getDocs, query, where, runTransaction, increment, serverTimestamp, updateDoc } from 'firebase/firestore';

/**
 * Satış tahsilatı kaydetme
 */
export const saveSalePayment = async (selectedSale, paymentData) => {
    if (!selectedSale) return;

    const amount = parseFloat(paymentData.tutar);
    if (amount <= 0) return;

    const newPaidAmount = (selectedSale.odenenTutar || 0) + amount;
    const newRemaining = selectedSale.toplamTutar - newPaidAmount;
    const newStatus = newRemaining <= 0 ? 'Tamamlandı' : 'Ödeme Bekliyor';

    // Düzeltme Modu
    if (paymentData.odemeYontemi === 'Cari Hesaptan / Daha Önce Alındı') {
        const saleRef = doc(db, "sales", selectedSale.id);
        await updateDoc(saleRef, {
            odenenTutar: increment(amount),
            kalanTutar: newRemaining,
            durum: newStatus
        });
        alert("Satış kaydı düzeltildi. (Müşteri bakiyesi ve kasa etkilenmedi)");
    } else {
        // Normal Tahsilat
        await runTransaction(db, async (transaction) => {
            const saleRef = doc(db, "sales", selectedSale.id);
            transaction.update(saleRef, {
                odenenTutar: increment(amount),
                kalanTutar: newRemaining,
                durum: newStatus
            });

            const customerRef = doc(db, "customers", selectedSale.musteriId);
            transaction.update(customerRef, { bakiye: increment(-amount) });

            const transactionRef = doc(collection(db, "transactions"));
            transaction.set(transactionRef, {
                customerId: selectedSale.musteriId,
                customerName: selectedSale.musteriAdSoyad,
                type: "tahsilat",
                amount: amount,
                paymentMethod: paymentData.odemeYontemi,
                description: paymentData.aciklama || `Satış Tahsilatı: #${selectedSale.id}`,
                timestamp: serverTimestamp(),
                refId: selectedSale.id,
                refType: 'sale'
            });
        });
        alert("Tahsilat başarıyla kaydedildi.");
    }
};

/**
 * Satış kaydı silme (cascade)
 */
export const deleteSaleRecord = async (sale) => {
    if (!window.confirm("Bu satış kaydını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz ve müşterinin cari hesabını etkiler.")) {
        return false;
    }

    try {
        // İlgili finansal işlemleri bul
        const transactionsRef = collection(db, "transactions");
        const qTrans = query(transactionsRef, where("refId", "==", sale.id), where("refType", "==", "sale"));
        const transSnapshot = await getDocs(qTrans);

        // İlgili cihazları bul
        const devicesRef = collection(db, "devices");
        const qDevices = query(devicesRef, where("satisRefId", "==", sale.id));
        const devicesSnapshot = await getDocs(qDevices);

        let totalDebt = 0;
        let totalPayment = 0;

        transSnapshot.docs.forEach(docSnap => {
            const data = docSnap.data();
            if (data.type === 'borc') totalDebt += Number(data.amount) || 0;
            if (data.type === 'tahsilat' || data.type === 'odeme') totalPayment += Number(data.amount) || 0;
        });

        const netBalanceEffect = totalDebt - totalPayment;

        await runTransaction(db, async (transaction) => {
            const customerRef = doc(db, "customers", sale.musteriId);
            const customerDoc = await transaction.get(customerRef);

            if (customerDoc.exists()) {
                transaction.update(customerRef, { bakiye: increment(-netBalanceEffect) });
            }

            // Stok iadesi
            if (sale.satilanUrunler && Array.isArray(sale.satilanUrunler)) {
                sale.satilanUrunler.forEach(item => {
                    if (item.tip === 'urun' && item.referansId && item.miktar > 0) {
                        const stockRef = doc(db, "stocks", item.referansId);
                        transaction.update(stockRef, { stokAdedi: increment(item.miktar) });
                    }
                });
            }

            // İlişkili cihazları sil
            devicesSnapshot.docs.forEach(deviceDoc => { transaction.delete(deviceDoc.ref); });

            // Satışı sil
            transaction.delete(doc(db, "sales", sale.id));

            // Transactionları sil
            transSnapshot.docs.forEach(docSnap => { transaction.delete(docSnap.ref); });
        });

        alert("Satış kaydı başarıyla silindi ve cari hesap güncellendi.");
        return true;
    } catch (error) {
        console.error("Satış silinirken hata:", error);
        alert("Silme işlemi sırasında bir hata oluştu: " + error.message);
        return false;
    }
};
